import { render, staticRenderFns } from "./CostBearersFilterModal.vue?vue&type=template&id=3f512828"
import script from "./CostBearersFilterModal.vue?vue&type=script&lang=ts"
export * from "./CostBearersFilterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports